import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api, mediaUrl, fmt } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { useCart } from "../lib/cart";
import { Check, ShoppingBag, Zap, FileDown } from "lucide-react";

const catLabel = { ebooks: "E-Book", templates: "Template", courses: "Course", bundles: "Bundle" };
const perks = ["Instant download after payment", "Lifetime access & updates", "Secure Stripe checkout"];

export default function ProductDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const { add, items } = useCart();
  const [p, setP] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/products/${id}`).then((r) => setP(r.data)).catch(() => setNotFound(true));
  }, [id]);

  const inCart = p && items.find((x) => x.id === p.id);

  if (notFound)
    return (
      <div className="App"><Navbar /><div className="max-w-3xl mx-auto px-6 py-32 text-center text-zinc-400">Product not found. <Link to="/" className="text-white underline">Back to store</Link></div></div>
    );
  if (!p) return <div className="App"><Navbar /><div className="max-w-7xl mx-auto px-6 py-32 animate-pulse text-zinc-600">Loading…</div></div>;

  return (
    <div className="App relative">
      <div className="vm-grain" />
      <Navbar />
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12 sm:py-16 relative z-10">
        <Link to="/" className="text-sm text-zinc-500 hover:text-white transition-colors">← Back</Link>
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 mt-6">
          <div className="vm-fade-up">
            <div className="rounded-2xl overflow-hidden border border-white/10 bg-zinc-900 aspect-[4/3]">
              <img src={mediaUrl(p.cover_path)} alt={p.title} className="w-full h-full object-cover" data-testid="product-image" />
            </div>
          </div>
          <div className="vm-fade-up" style={{ animationDelay: "100ms" }}>
            <span className="text-[11px] tracking-[0.2em] uppercase px-3 py-1 rounded-full border border-white/15 text-zinc-300">{catLabel[p.category]}</span>
            <h1 className="font-head text-3xl sm:text-4xl tracking-tight font-light mt-5" data-testid="product-title">{p.title}</h1>
            <p className="text-zinc-400 mt-4 leading-relaxed font-light">{p.description}</p>
            <div className="mt-8 flex items-baseline gap-3">
              <span className="font-mono text-3xl text-white" data-testid="product-price">{fmt(p.price)}</span>
              <span className="text-sm text-zinc-500">one-time</span>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button
                data-testid="add-to-cart-button"
                onClick={() => add(p)}
                disabled={!!inCart}
                className="inline-flex items-center justify-center gap-2 bg-white text-black px-6 py-3.5 rounded-md font-medium hover:bg-zinc-200 transition-colors disabled:opacity-50"
              >
                {inCart ? <><Check className="w-4 h-4" /> In cart</> : <><ShoppingBag className="w-4 h-4" /> Add to cart</>}
              </button>
              <button
                data-testid="buy-now-button"
                onClick={() => { if (!inCart) add(p); nav("/cart"); }}
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border border-white/20 hover:border-white/50 transition-colors"
              >
                <Zap className="w-4 h-4" /> Buy now
              </button>
            </div>
            <ul className="mt-10 space-y-3 border-t border-white/10 pt-8">
              {perks.map((t) => (
                <li key={t} className="flex items-center gap-3 text-sm text-zinc-300">
                  <FileDown className="w-4 h-4 text-emerald-400" /> {t}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
